import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/Modal';

interface Props {
  open: boolean;
  bookTitle?: string | null;
  bookAuthor?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function OpenBookConfirm({ open, bookTitle, bookAuthor, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onCancel} title={t('shelf.open_book_confirm_title')} height={260}>
      <div className="px-4 py-4 flex flex-col gap-5">
        <div>
          <div className="text-sm text-text-muted">{t('shelf.open_book_confirm_body')}</div>
          <div className="mt-2">
            <div className="text-sm font-medium italic text-text break-words">
              {bookTitle ?? t('shelf.no_title')}
            </div>
            {bookAuthor && (
              <div className="text-xs text-text-muted break-words">{bookAuthor}</div>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-pill bg-surface text-text text-sm font-medium"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-pill bg-accent text-text-inverse text-sm font-medium"
          >
            {t('shelf.open_book_confirm_cta')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
